// extracted by mini-css-extract-plugin
export default {"description":"VerificationForm_description__Ct9ND","continueButton":"VerificationForm_continueButton__B7Ad3","radioGroup":"VerificationForm_radioGroup__GqjE0"};